export function indexWarehousesUseCase(warehouseRepostitory) {
    return warehouseRepostitory.index();
}